import { cn } from '../lib/utils';
import { getActiveTableUiPreset, isRefinedTableUi } from './tableUiThemeRuntime';

const REFINED = {
  base: 'inline-flex items-center max-w-full truncate rounded-md px-2 py-0.5 text-xs font-medium leading-snug border',
  neutral:
    'bg-slate-100/80 text-slate-700 border-slate-300/70 dark:bg-slate-800/45 dark:text-slate-200 dark:border-slate-500/45',
  blue: 'bg-blue-100/80 text-blue-800 border-blue-200/80 dark:bg-blue-950/35 dark:text-blue-200 dark:border-blue-800/45',
  emerald:
    'bg-emerald-100/80 text-emerald-800 border-emerald-200/80 dark:bg-emerald-950/30 dark:text-emerald-200 dark:border-emerald-800/45',
  rose: 'bg-rose-100/80 text-rose-800 border-rose-200/80 dark:bg-rose-950/30 dark:text-rose-200 dark:border-rose-800/45',
  orange:
    'bg-orange-100/80 text-orange-800 border-orange-200/80 dark:bg-orange-950/30 dark:text-orange-200 dark:border-orange-800/45',
  violet:
    'bg-violet-100/80 text-violet-800 border-violet-200/80 dark:bg-violet-950/30 dark:text-violet-200 dark:border-violet-800/45',
  fuchsia:
    'bg-fuchsia-100/80 text-fuchsia-800 border-fuchsia-200/80 dark:bg-fuchsia-950/30 dark:text-fuchsia-200 dark:border-fuchsia-800/45',
  amber:
    'bg-amber-100/80 text-amber-800 border-amber-200/80 dark:bg-amber-950/30 dark:text-amber-200 dark:border-amber-800/45',
  sky: 'bg-sky-100/80 text-sky-800 border-sky-200/80 dark:bg-sky-950/30 dark:text-sky-200 dark:border-sky-800/45',
  status: {
    pending:
      'bg-amber-100/80 text-amber-800 border-amber-200/80 dark:bg-amber-950/30 dark:text-amber-200 dark:border-amber-800/45',
    approved:
      'bg-emerald-100/80 text-emerald-800 border-emerald-200/80 dark:bg-emerald-950/30 dark:text-emerald-200 dark:border-emerald-800/45',
    rejected:
      'bg-rose-100/80 text-rose-800 border-rose-200/80 dark:bg-rose-950/30 dark:text-rose-200 dark:border-rose-800/45',
    cancelled:
      'bg-slate-100/80 text-slate-600 border-slate-300/70 dark:bg-slate-800/45 dark:text-slate-300 dark:border-slate-500/45',
    active:
      'bg-emerald-100/80 text-emerald-800 border-emerald-200/80 dark:bg-emerald-950/30 dark:text-emerald-200 dark:border-emerald-800/45',
    inactive:
      'bg-slate-100/80 text-slate-600 border-slate-300/70 dark:bg-slate-800/45 dark:text-slate-300 dark:border-slate-500/45',
    'expiring soon':
      'bg-amber-100/80 text-amber-800 border-amber-200/80 dark:bg-amber-950/30 dark:text-amber-200 dark:border-amber-800/45',
    expired:
      'bg-rose-100/80 text-rose-800 border-rose-200/80 dark:bg-rose-950/30 dark:text-rose-200 dark:border-rose-800/45',
    renewed:
      'bg-sky-100/80 text-sky-800 border-sky-200/80 dark:bg-sky-950/30 dark:text-sky-200 dark:border-sky-800/45',
    overdue:
      'bg-orange-100/80 text-orange-800 border-orange-200/80 dark:bg-orange-950/30 dark:text-orange-200 dark:border-orange-800/45',
    open: 'bg-amber-100/80 text-amber-800 border-amber-200/80 dark:bg-amber-950/30 dark:text-amber-200 dark:border-amber-800/45',
    'in progress':
      'bg-sky-100/80 text-sky-800 border-sky-200/80 dark:bg-sky-950/30 dark:text-sky-200 dark:border-sky-800/45',
    in_progress:
      'bg-sky-100/80 text-sky-800 border-sky-200/80 dark:bg-sky-950/30 dark:text-sky-200 dark:border-sky-800/45',
    resolved:
      'bg-emerald-100/80 text-emerald-800 border-emerald-200/80 dark:bg-emerald-950/30 dark:text-emerald-200 dark:border-emerald-800/45',
    sent: 'bg-emerald-100/80 text-emerald-800 border-emerald-200/80 dark:bg-emerald-950/30 dark:text-emerald-200 dark:border-emerald-800/45',
    failed: 'bg-rose-100/80 text-rose-800 border-rose-200/80 dark:bg-rose-950/30 dark:text-rose-200 dark:border-rose-800/45',
    skipped: 'bg-amber-100/80 text-amber-800 border-amber-200/80 dark:bg-amber-950/30 dark:text-amber-200 dark:border-amber-800/45',
  },
  entityType: {
    document: 'bg-blue-100/80 text-blue-800 border-blue-200/80 dark:bg-blue-950/35 dark:text-blue-200 dark:border-blue-800/45',
    non_conformity_report:
      'bg-rose-100/80 text-rose-800 border-rose-200/80 dark:bg-rose-950/30 dark:text-rose-200 dark:border-rose-800/45',
    'non-conformity-report':
      'bg-rose-100/80 text-rose-800 border-rose-200/80 dark:bg-rose-950/30 dark:text-rose-200 dark:border-rose-800/45',
    capa: 'bg-orange-100/80 text-orange-800 border-orange-200/80 dark:bg-orange-950/30 dark:text-orange-200 dark:border-orange-800/45',
    change_request:
      'bg-violet-100/80 text-violet-800 border-violet-200/80 dark:bg-violet-950/30 dark:text-violet-200 dark:border-violet-800/45',
    complaint:
      'bg-fuchsia-100/80 text-fuchsia-800 border-fuchsia-200/80 dark:bg-fuchsia-950/30 dark:text-fuchsia-200 dark:border-fuchsia-800/45',
    default:
      'bg-slate-100/80 text-slate-700 border-slate-300/70 dark:bg-slate-800/45 dark:text-slate-200 dark:border-slate-500/45',
  },
  approval: {
    single: 'bg-blue-100/80 text-blue-800 border-blue-200/80 dark:bg-blue-950/35 dark:text-blue-200 dark:border-blue-800/45',
    sequential:
      'bg-emerald-100/80 text-emerald-800 border-emerald-200/80 dark:bg-emerald-950/30 dark:text-emerald-200 dark:border-emerald-800/45',
    parallel:
      'bg-violet-100/80 text-violet-800 border-violet-200/80 dark:bg-violet-950/30 dark:text-violet-200 dark:border-violet-800/45',
    any_one:
      'bg-orange-100/80 text-orange-800 border-orange-200/80 dark:bg-orange-950/30 dark:text-orange-200 dark:border-orange-800/45',
    default:
      'bg-slate-100/80 text-slate-700 border-slate-300/70 dark:bg-slate-800/45 dark:text-slate-200 dark:border-slate-500/45',
  },
  workflow: {
    review: 'bg-blue-100/80 text-blue-800 border-blue-200/80 dark:bg-blue-950/35 dark:text-blue-200 dark:border-blue-800/45',
    approval:
      'bg-emerald-100/80 text-emerald-800 border-emerald-200/80 dark:bg-emerald-950/30 dark:text-emerald-200 dark:border-emerald-800/45',
    review_approval:
      'bg-violet-100/80 text-violet-800 border-violet-200/80 dark:bg-violet-950/30 dark:text-violet-200 dark:border-violet-800/45',
    default:
      'bg-slate-100/80 text-slate-700 border-slate-300/70 dark:bg-slate-800/45 dark:text-slate-200 dark:border-slate-500/45',
  },
  priority: {
    urgent: 'bg-rose-100/80 text-rose-800 border-rose-200/80 dark:bg-rose-950/30 dark:text-rose-200 dark:border-rose-800/45',
    high: 'bg-orange-100/80 text-orange-800 border-orange-200/80 dark:bg-orange-950/30 dark:text-orange-200 dark:border-orange-800/45',
    medium: 'bg-amber-100/80 text-amber-800 border-amber-200/80 dark:bg-amber-950/30 dark:text-amber-200 dark:border-amber-800/45',
    low: 'bg-blue-100/80 text-blue-800 border-blue-200/80 dark:bg-blue-950/35 dark:text-blue-200 dark:border-blue-800/45',
    default:
      'bg-slate-100/80 text-slate-700 border-slate-300/70 dark:bg-slate-800/45 dark:text-slate-200 dark:border-slate-500/45',
  },
};

const LEGACY = {
  base: 'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium',
  neutral: 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-200',
  emerald: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200',
  blue: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200',
  violet: 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200',
  amber: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200',
  pill: (theme, colorKey) => {
    if (!theme?.colors) {
      const fallback = {
        info: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200',
        primary: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200',
        success: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200',
        warning: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200',
        danger: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200',
        gray: 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-200',
      };
      return fallback[colorKey] || fallback.gray;
    }
    const map = {
      info: cn(theme.colors.info, theme.text.inverse),
      primary: cn(theme.colors.primary, theme.text.inverse),
      success: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200',
      warning: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200',
      danger: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200',
      gray: 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-200',
    };
    return map[colorKey] || map.gray;
  },
  status: {
    pending: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200',
    approved: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200',
    rejected: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200',
    cancelled: 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-200',
    active: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200',
    inactive: 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-200',
    'expiring soon': 'bg-amber-100 text-amber-800 dark:bg-amber-900 dark:text-amber-200',
    expired: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200',
    renewed: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200',
    overdue: 'bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-200',
    open: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200',
    'in progress': 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200',
    in_progress: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200',
    resolved: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200',
    sent: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200',
    failed: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200',
    skipped: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200',
  },
  entityType: {
    document: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200',
    non_conformity_report: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200',
    'non-conformity-report': 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200',
    capa: 'bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-200',
    change_request: 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200',
    complaint: 'bg-pink-100 text-pink-800 dark:bg-pink-900 dark:text-pink-200',
    default: 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-200',
  },
  approval: {
    single: 'bg-blue-100 text-blue-800',
    sequential: 'bg-green-100 text-green-800',
    parallel: 'bg-purple-100 text-purple-800',
    any_one: 'bg-orange-100 text-orange-800',
    default: 'bg-gray-100 text-gray-800',
  },
  workflow: {
    review: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200',
    approval: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200',
    review_approval: 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200',
    default: 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-200',
  },
  priority: {
    urgent: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200',
    high: 'bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-200',
    medium: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200',
    low: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200',
    default: 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-200',
  },
};

export function getBadgeStyleTokens() {
  return getActiveTableUiPreset().id === 'legacy' ? LEGACY : REFINED;
}

export function badgeClass(colorClasses, theme) {
  const tokens = getBadgeStyleTokens();
  if (tokens === REFINED) {
    return cn(REFINED.base, colorClasses);
  }
  if (typeof colorClasses === 'function') {
    return cn(LEGACY.base, colorClasses(theme ?? {}));
  }
  return cn(LEGACY.base, colorClasses);
}

const COLOR_NAME_TO_TOKEN = {
  red: 'rose',
  green: 'emerald',
  blue: 'blue',
  yellow: 'amber',
  orange: 'orange',
  purple: 'violet',
  pink: 'fuchsia',
  gray: 'neutral',
  grey: 'neutral',
  cyan: 'sky',
  teal: 'emerald',
  indigo: 'blue',
  success: 'emerald',
  warning: 'amber',
  error: 'rose',
  danger: 'rose',
  info: 'sky',
  primary: 'blue',
};

const NAMED_COLOR_HEX = {
  red: '#EF4444',
  green: '#22C55E',
  blue: '#3B82F6',
  yellow: '#EAB308',
  orange: '#F97316',
  purple: '#A855F7',
  pink: '#EC4899',
  gray: '#6B7280',
  grey: '#6B7280',
};

function hexToRgba(hex, alpha) {
  const h = String(hex || '').replace('#', '');
  const full =
    h.length === 3 ? h.split('').map((c) => c + c).join('') : h.length === 6 ? h : null;
  if (!full) return `rgba(100, 116, 139, ${alpha})`;
  const r = parseInt(full.slice(0, 2), 16);
  const g = parseInt(full.slice(2, 4), 16);
  const b = parseInt(full.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

function normalizeHexColor(color) {
  const raw = String(color || '').trim();
  if (raw.startsWith('#')) return raw;
  const lower = raw.toLowerCase();
  if (NAMED_COLOR_HEX[lower]) return NAMED_COLOR_HEX[lower];
  return null;
}

/** Related lookup row for badge/status columns (uses .color when configured in admin). */
export function resolveBadgeEntity(column, row, value) {
  if (value && typeof value === 'object' && !Array.isArray(value)) return value;
  const key = column?.key || column?.name || '';
  if (key.endsWith('Id')) {
    const base = key.slice(0, -2);
    const candidates = [
      base,
      base.replace(/Status$/, 'Status'),
      base.replace(/Type$/, 'Type'),
      base.replace(/Category$/, 'Category'),
    ];
    for (const name of [...new Set(candidates)]) {
      if (row?.[name] && typeof row[name] === 'object') return row[name];
    }
  }
  const df = column?.displayField;
  if (df && row?.[df] && typeof row[df] === 'object') return row[df];
  if (df && typeof row?.[df] === 'string') {
    const guess = df.replace(/(Label|Name|Title|Display)$/i, '');
    if (row?.[guess] && typeof row[guess] === 'object') return row[guess];
  }
  return null;
}

/** Badge classes (+ optional inline style) from admin color field (hex or name). */
export function getBadgePresentationForColor(color, theme) {
  const tokens = getBadgeStyleTokens();
  const raw = String(color || '').trim();
  if (!raw) {
    return { className: badgeClass(tokens.neutral, theme), style: undefined };
  }

  const tokenKey = COLOR_NAME_TO_TOKEN[raw.toLowerCase()];
  if (tokenKey && tokens[tokenKey]) {
    return { className: badgeClass(tokens[tokenKey], theme), style: undefined };
  }

  const hex = normalizeHexColor(raw);
  if (hex) {
    if (tokens === REFINED) {
      return {
        className: cn(REFINED.base, 'border'),
        style: {
          backgroundColor: hexToRgba(hex, 0.14),
          borderColor: hexToRgba(hex, 0.35),
          color: hex,
        },
      };
    }
    return {
      className: LEGACY.base,
      style: { backgroundColor: hex, color: '#ffffff' },
    };
  }

  return { className: badgeClass(tokens.blue ?? tokens.neutral, theme), style: undefined };
}

function statusKey(status) {
  return String(status?.name ?? status ?? '')
    .toLowerCase()
    .replace(/_/g, ' ');
}

export function statusBadgeClassName(status, theme) {
  const tokens = getBadgeStyleTokens();
  const key = statusKey(status);
  return badgeClass(tokens.status[key] || tokens.status.cancelled || tokens.neutral, theme);
}

export function priorityBadgeClassName(priority, theme) {
  const tokens = getBadgeStyleTokens();
  const key = statusKey(priority);
  return badgeClass(tokens.priority[key] || tokens.priority.default, theme);
}

export function ticketingStatusBadgeClassName(status, theme) {
  const normalized = String(status || 'OPEN').toUpperCase().replace(/\s+/g, '_');
  const map = {
    OPEN: 'open',
    IN_PROGRESS: 'in_progress',
    RESOLVED: 'resolved',
    CANCELLED: 'cancelled',
  };
  const tokens = getBadgeStyleTokens();
  const key = map[normalized] || 'open';
  return badgeClass(tokens.status[key] || tokens.status.open, theme);
}

const DEPARTMENT_PALETTES_REFINED = [
  REFINED.neutral,
  REFINED.blue,
  REFINED.emerald,
  REFINED.violet,
  REFINED.amber,
  REFINED.rose,
  REFINED.sky,
  REFINED.orange,
  REFINED.blue,
  REFINED.emerald,
];

const DEPARTMENT_PALETTES_LEGACY = [
  'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-200',
  'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200',
  'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200',
  'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200',
  'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200',
  'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200',
  'bg-cyan-100 text-cyan-800 dark:bg-cyan-900 dark:text-cyan-200',
  'bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-200',
  'bg-indigo-100 text-indigo-800 dark:bg-indigo-900 dark:text-indigo-200',
  'bg-teal-100 text-teal-800 dark:bg-green-900 dark:text-green-200',
];

export function departmentBadgeClassName(paletteIndex, theme) {
  const palettes =
    getBadgeStyleTokens() === REFINED ? DEPARTMENT_PALETTES_REFINED : DEPARTMENT_PALETTES_LEGACY;
  const idx = Math.abs(Number(paletteIndex) || 0) % palettes.length;
  return badgeClass(palettes[idx], theme);
}

export function scheduleRunStatusBadgeClassName(status, theme) {
  const key = String(status || '').toLowerCase();
  const tokens = getBadgeStyleTokens();
  return badgeClass(tokens.status[key] || tokens.status.cancelled || tokens.neutral, theme);
}

/** Secondary label (e.g. ticketing category under department). */
export function categoryBadgeClassName(theme) {
  return badgeClass(getBadgeStyleTokens().neutral, theme);
}

/** Attachment row: ticket vs comments thread. */
export function attachmentSourceBadgeClassName(source, theme) {
  const tokens = getBadgeStyleTokens();
  const isComments = source === 'comments';
  const color = isComments ? tokens.violet || tokens.blue : tokens.neutral;
  return badgeClass(color, theme);
}

/** Small numeric chip (message count in queue preview). */
export function messageCountChipClassName(theme) {
  const tokens = getBadgeStyleTokens();
  if (tokens === REFINED) {
    return cn(
      'shrink-0 rounded-md px-1.5 py-0.5 text-[10px] font-semibold tabular-nums border',
      REFINED.neutral
    );
  }
  return cn(
    'shrink-0 rounded-md px-1.5 py-0.5 text-[10px] font-semibold tabular-nums',
    'bg-slate-200/90 text-slate-700 dark:bg-slate-700/80 dark:text-slate-200'
  );
}

export function assigneeHistoryStepBadgeClassName(theme) {
  return badgeClass(getBadgeStyleTokens().blue, theme);
}

/** Ticket # links and download actions in ticketing tables. */
export function ticketingLinkClassName(theme) {
  const tokens = getBadgeStyleTokens();
  if (tokens === REFINED) {
    return 'text-sky-700 dark:text-sky-300 hover:underline';
  }
  return 'text-blue-600 dark:text-blue-400 hover:underline';
}

export function ticketingInfoPanelClassName(theme) {
  if (isRefinedTableUi()) {
    return cn(
      'rounded-lg border px-3 py-2.5',
      'border-slate-200/80 dark:border-slate-600/50',
      'bg-slate-50/60 dark:bg-slate-800/25'
    );
  }
  return cn(
    'rounded-lg border px-3 py-2.5',
    'border-blue-200/80 dark:border-blue-800/60',
    'bg-blue-50/80 dark:bg-blue-950/30'
  );
}

export function ticketingInfoPanelTitleClassName(theme) {
  const tokens = getBadgeStyleTokens();
  if (tokens === REFINED) {
    return 'text-slate-700 dark:text-slate-300';
  }
  return 'text-blue-700 dark:text-blue-300';
}

export function ticketingExpandedPayloadBgClassName(theme) {
  if (isRefinedTableUi()) {
    return 'bg-slate-50/80 dark:bg-slate-950/35';
  }
  return 'bg-slate-50/90 dark:bg-slate-950/40';
}

export function ticketingDropZoneActiveClassName() {
  if (isRefinedTableUi()) {
    return 'border-sky-400/80 bg-sky-50/40 dark:border-sky-600/60 dark:bg-sky-950/25';
  }
  return 'border-blue-500 bg-blue-50/80 dark:border-blue-400 dark:bg-blue-950/30';
}

export function ticketingDropZoneIdleClassName(theme) {
  if (isRefinedTableUi()) {
    return 'border-slate-200/80 bg-slate-50/50 dark:border-slate-600/50 dark:bg-slate-900/30';
  }
  return cn(theme?.border?.light || 'border-gray-200', 'bg-slate-50/70 dark:bg-slate-900/30');
}

/** Ticketing Setup — page hero banner. */
export function setupPageHeroClassName() {
  if (isRefinedTableUi()) {
    return cn(
      'rounded-2xl border p-4 md:p-5',
      'border-slate-200/80 dark:border-slate-600/50',
      'bg-white/90 dark:bg-slate-800/35 shadow-sm'
    );
  }
  return 'rounded-2xl border border-blue-200/70 bg-gradient-to-r from-blue-50 to-indigo-50 p-4 md:p-5';
}

/** Accent strip on top of setup cards. */
export function setupCardAccentBarClassName() {
  if (isRefinedTableUi()) {
    return 'h-1 w-full bg-gradient-to-r from-slate-300/90 via-slate-400/80 to-slate-300/90 dark:from-slate-600 dark:via-slate-500 dark:to-slate-600';
  }
  return 'h-1.5 w-full bg-gradient-to-r from-blue-600 via-indigo-500 to-sky-500';
}

/** Selectable department row in Ticketing Setup. */
export function setupSelectedCardClassName(isSelected) {
  if (isRefinedTableUi()) {
    return isSelected
      ? 'border-sky-400/70 bg-sky-50/35 dark:border-sky-600/55 dark:bg-sky-950/25 shadow-sm'
      : 'border-slate-200/80 dark:border-slate-600/50 hover:bg-slate-50/70 dark:hover:bg-slate-800/35';
  }
  return isSelected
    ? 'border-blue-500 bg-blue-50/80 dark:bg-blue-900/20 shadow-sm'
    : 'border-gray-200 dark:border-gray-700 hover:bg-gray-50/90 dark:hover:bg-gray-800';
}

/** Sticky category group label in Ticketing Setup. */
export function setupGroupHeaderClassName() {
  const tokens = getBadgeStyleTokens();
  if (tokens === REFINED) {
    return cn(
      'sticky top-0 z-10 py-1.5 px-2.5 rounded-lg text-xs font-semibold backdrop-blur',
      REFINED.neutral
    );
  }
  return 'sticky top-0 z-10 py-1.5 px-2.5 rounded-lg bg-slate-100/95 backdrop-blur text-xs font-semibold text-slate-600 border border-slate-200 dark:border-slate-600 dark:text-slate-300';
}

/** Order / index chip in setup lists. */
export function setupOrderChipClassName(theme) {
  return categoryBadgeClassName(theme);
}

/** Todo Calendar — drop target highlight (day cell or unscheduled panel). */
export function calendarDragOverClassName() {
  if (isRefinedTableUi()) {
    return 'ring-2 ring-sky-400/45 bg-sky-50/35 dark:ring-sky-600/40 dark:bg-sky-950/20';
  }
  return 'ring-2 ring-blue-500/50 bg-blue-50/80';
}

/** Todo Calendar — days outside the visible month. */
export function calendarOutsideMonthClassName() {
  if (isRefinedTableUi()) {
    return 'bg-slate-50/50 dark:bg-slate-900/25';
  }
  return 'bg-slate-50/70';
}

/** Todo Calendar — today’s date number. */
export function calendarTodayDayClassName() {
  if (isRefinedTableUi()) {
    return 'inline-flex h-5 w-5 items-center justify-center rounded-full bg-sky-600 text-white text-xs dark:bg-sky-500';
  }
  return 'inline-flex h-5 w-5 items-center justify-center rounded-full bg-blue-600 text-white';
}

/** Todo card on calendar grid. status: 'done' | 'overdue' | 'open'
 *  Do NOT use badgeClass() here — REFINED.base includes truncate/inline-flex
 *  which collapses the card to a single text line and hides switch/assignees.
 */
export function todoCalendarEventClassName(statusOrCompleted, theme) {
  const tokens = getBadgeStyleTokens();
  const status =
    typeof statusOrCompleted === 'string'
      ? statusOrCompleted
      : statusOrCompleted
        ? 'done'
        : 'open';
  const base =
    'relative block w-full min-w-0 text-[11px] leading-snug pl-2 pr-1.5 py-1.5 rounded-md border cursor-pointer shadow-sm';
  const tone =
    status === 'done'
      ? tokens.emerald
      : status === 'overdue'
        ? tokens.rose
        : tokens.amber;
  const colorClasses = typeof tone === 'function' ? tone(theme ?? {}) : tone;
  return cn(base, colorClasses, status === 'done' && 'opacity-90');
}

/** Compact status pill inside a calendar todo card. */
export function todoCalendarStatusPillClassName(status, theme) {
  const tokens = getBadgeStyleTokens();
  const base = 'inline-flex items-center rounded px-1.5 py-0.5 text-[9px] font-semibold uppercase tracking-wide';
  if (status === 'done') return cn(base, badgeClass(tokens.emerald, theme));
  if (status === 'overdue') return cn(base, badgeClass(tokens.rose, theme));
  return cn(base, badgeClass(tokens.blue, theme));
}

/** Attachment count on todo calendar cards. */
export function todoAttachmentChipClassName(theme) {
  return cn(
    'inline-flex items-center gap-0.5 rounded px-1 py-0.5 text-[10px]',
    categoryBadgeClassName(theme),
  );
}

/** Unscheduled sidebar todo row shell. */
export function todoUnscheduledCardClassName(completed, theme) {
  const tokens = getBadgeStyleTokens();
  const base = 'relative block w-full min-w-0 rounded-md border pl-2 pr-1.5 py-1 text-xs cursor-pointer shadow-sm';
  if (completed) {
    if (tokens === REFINED) {
      return cn(base, tokens.emerald);
    }
    return cn(base, 'border-emerald-200 bg-emerald-50 text-emerald-800 dark:border-emerald-800 dark:bg-emerald-950/30 dark:text-emerald-200');
  }
  if (tokens === REFINED) {
    return cn(
      base,
      'border-slate-200/80 dark:border-slate-600/50',
      'bg-white/90 dark:bg-slate-800/35 hover:bg-slate-50/90 dark:hover:bg-slate-800/55',
    );
  }
  return cn(base, theme?.border?.light || 'border-gray-200', theme?.colors?.surface || 'bg-white');
}

/** Linked user-department label on ticketing department cards. */
export function setupLinkedDeptBadgeClassName(theme) {
  return badgeClass(getBadgeStyleTokens().blue, theme);
}
